import { MmmModelOutput } from '../mmmModelOutput';
import {
  AxisChartByNumberPrediction,
  DataPointSetByNumberOptimisation,
  DataPointSetByNumberPrediction,
  DataPointSetStyle
} from 'features/charts/chart.models';

export interface AxisChartByNumberPredictionCalculation {
  chart: AxisChartByNumberPrediction;
}

export interface DataPointSetByNumberOptimsationResult {
  dataPointSet: DataPointSetByNumberOptimisation;
  spend: number;
  sourceCategoryName: string;
}

export const createDataPointSetByNumberPredictions = (
  mmmResponse: MmmModelOutput
): DataPointSetByNumberPrediction[] => {
  const dataPointSets: DataPointSetByNumberPrediction[] =
    mmmResponse.forecasts.flatMap((forecast) =>
      forecast.returnValues.map((value, index) => {
        const isPredictive = index >= forecast.maximumRealSpend;

        const style = isPredictive
          ? DataPointSetStyle.DASHED
          : DataPointSetStyle.SOLID;

        const dataPointSetName = isPredictive
          ? `Predictive ${forecast.sourceCategoryDisplayName}`
          : forecast.sourceCategoryDisplayName;

        const parentDataPointSetName = isPredictive
          ? forecast.sourceCategoryDisplayName
          : '';

        const dataPoint: DataPointSetByNumberPrediction = {
          xValue: index * mmmResponse.dayMultiplier,
          yValue: value * mmmResponse.dayMultiplier,
          dataPointSetName,
          actualParentDataPointSetName: parentDataPointSetName,
          style
        };

        return dataPoint;
      })
    );

  return dataPointSets;
};

export const createDataPointSetsByNumberOptimsation = (
  mmmResponse: MmmModelOutput
): DataPointSetByNumberOptimisation[] => {
  const dataPointSets: DataPointSetByNumberOptimisation[] = [];

  for (const forecast of mmmResponse.forecasts) {
    for (
      let spendIterable = 0;
      spendIterable < forecast.maximumForecastSpend + 1;
      spendIterable++
    ) {
      const dataPointSet: DataPointSetByNumberOptimisation = {
        xValue: spendIterable * mmmResponse.dayMultiplier,
        yValue:
          forecast.returnValues[spendIterable] * mmmResponse.dayMultiplier,
        dataPointSetName: forecast.sourceCategoryDisplayName
      };

      dataPointSets.push(dataPointSet);
    }
  }

  return dataPointSets;
};
